import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material';
import TableView from '../../components/tableview';
import { useNavigate, useParams } from 'react-router-dom';
import ValidatePageAccess from '../../components/api/ValidatePageAccess'

const TableData = () => {
    const [pageAccess, SetPageAcces] = useState(false)
    const { siteId } = useParams()
    const navigate = useNavigate()

    useEffect(() => {
        const GetPageAccess = async () => {
          let response = await ValidatePageAccess(siteId, 'comfort/table')
          SetPageAcces(response)
          if(!response) navigate(`/projects/${siteId}`)
        } 
        GetPageAccess()
    }, [siteId, navigate])

    return (
        <Box sx={{margin:'18px'}}>
            {
                pageAccess ? (
                    <TableView showSearch={true} color='#f2f0f0'/>
                ) : (
                    <></>
                )
            }
        </Box>
    )
}

export default TableData
